module.exports = __webpack_public_path__ + "img/п.2.feff499d.png";